export enum RequestState {
  Success,
  Failed,
  Pending,
  Unset,
}
